import { Card, Divider, Skeleton } from 'antd';
import classNames from 'classnames';

import styles from './TabSkeleton.module.scss';

const DEFAULT_COLUMNS_COUNT = 16;

export type SkeletonRowType = 'avatar-row' | 'input-row' | 'left-only-row';

type TabSkeletonItemProps = {
  rows: readonly SkeletonRowType[];
  columnsCount?: number;
  headerButton?: boolean;
};

const TabSkeletonItem = ({
  rows,
  columnsCount = DEFAULT_COLUMNS_COUNT,
  headerButton = false,
}: TabSkeletonItemProps) => {
  const columns = Array.from({ length: columnsCount });

  return (
    <Card className={styles.card} bodyStyle={{ padding: 0 }}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Skeleton.Button active size="small" className={styles.chevron} />
          <Skeleton.Avatar active shape="square" size="small" />
          <Skeleton.Input active className={styles.titleInput} size="small" />
        </div>
        {headerButton && (
          <div className={styles.headerActions}>
            <Skeleton.Button
              active
              size="small"
              className={styles.headerButton}
            />
            <Skeleton.Button
              active
              size="small"
              className={styles.headerIconButton}
            />
          </div>
        )}
      </div>

      <Divider className={styles.divider} />

      <div className={styles.tableWrap}>
        {rows.map((rowType, i) => (
          <div
            key={i}
            className={classNames([styles.row, styles[`${rowType}`]])}
          >
            <div className={styles.leftCell}>
              <Skeleton.Input
                active
                className={styles['smallInput--wide']}
                size="small"
              />
            </div>
            {rowType === 'avatar-row' && (
              <div className={styles.center}>
                {columns.map((_, j) => (
                  <Skeleton.Avatar
                    key={j}
                    active
                    size={20}
                    shape="circle"
                    className={styles.smallAvatar}
                  />
                ))}
              </div>
            )}
            {rowType === 'input-row' && (
              <div className={styles.center}>
                {columns.map((_, j) => (
                  <Skeleton.Input
                    key={j}
                    active
                    className={styles['smallInput--narrow']}
                    size="small"
                  />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
};

type TabSkeletonProps = {
  count: number;
  rows: readonly SkeletonRowType[];
  columnsCount?: number;
  headerButton?: boolean;
};

export const TabSkeleton = ({
  count,
  rows,
  columnsCount,
  headerButton,
}: TabSkeletonProps) => {
  const items = Array.from({ length: count });

  return (
    <div className={styles.loadingContainer}>
      {items.map((_, i) => (
        <TabSkeletonItem
          key={i}
          rows={rows}
          columnsCount={columnsCount}
          headerButton={headerButton}
        />
      ))}
    </div>
  );
};
